(function(){
    window.gtmEvent = function(payload){
        var message = JSON.stringify({
            type : 'gtm',
            payload : payload
        });
        parent.postMessage(message, '*');
    };
})();